import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { fetchCartDetails } from "../../redux/actions/cartActions"
import { CustomDataTable } from "../../components"
import { RiEyeLine } from "react-icons/ri"
import { useNavigate } from "react-router-dom"
import { IMG } from "../../constant"

const Cart = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.admin);
  const { carts, loader, errors } = useSelector((state) => state.cart);
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      dispatch(fetchCartDetails({ token }));
    }
  }, [dispatch, token]);

  console.log("Cart Details", JSON.stringify(carts,0,2))

  const handleView = (id) => {
    const url = `/cart/${id}`;
    window.open(url, '_blank'); // '_blank' opens in a new tab
  };
  
  const formattedDate = (dateString) => {
    // Format date: Sun, Apr 6, 2025
    if (!dateString) return "";
    const createdAt = new Date(dateString);
    console.log("FormattedDate", createdAt)
    return createdAt.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    })
  }

  const formattedTime = (dateString) => {
    // Format time: 06:33 PM
    if (!dateString) return "";
    const createdAt = new Date(dateString);
    return createdAt.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
  }
  

  const columns = [
    {
      name: "Customer",
      selector: (row) => {
        try {
          // const user = JSON.parse(row.user); // Convert JSON string to an object
          return (
            <div className="dprofile">
              <img src={IMG.DP} alt="dp" />
              <div className="items">
                <span className="name fw-600">{row.user.latest_address ? `${row.user.latest_address?.fname} ${row.user.latest_address?.lname}` : `${row.user.name}`}</span>
                <span className="email text-neutral-dark-200 fs-xs">{`${row.user.email}`}</span>
                {/* <span className="phone text-neutral-dark-200 fs-xs">{row.user.latest_address ? `${row.user.latest_address?.phone}` : row.user.mobile === 'empty' || row.user.mobile === null ? null : row.user.mobile }</span> */}
              </div>
            </div>
          );
        } catch (error) {
          return "Invalid Address"; // Handle JSON parsing errors
        }
      },
       width: "250px"
    },
    {
      name: <span className="cellHeading">Amount</span>,
      selector: (row) => {
        return (
          <div>
            <span className="fw-600 fs-md">{'₹'+ (row.total - row.discountedTotal)}.00</span> <br />
            <span className="text-neutral-dark-200 fs-xs">
              { row.totalProducts > 1 ? `(${row.totalProducts} Items)` : `(${row.totalProducts} Item)` }
            </span>
          </div>
        )
      },
      width: "150px",
    },
    {
      name: <span className="cellHeading">Last_added</span>,
      selector: (row) => (
        // <span className="text-neutral-dark-600 fs-sm">{formattedDate(row.updated_at)}, <br /> {formattedTime(row.updated_at)}</span>
        <span className="text-neutral-dark-600 fs-sm">{formattedDate(row.created_at)}, <br /> {formattedTime(row.created_at)}</span>
      ),
      width: "150px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="actionsWrapper">
           <div onClick={() => handleView(row.id, row.po_number)}>
            <RiEyeLine />
          </div>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },    
    
  ];

  return (
    <div>
      {loader && <p>Loading...</p>}
      {errors && <p style={{ color: "red" }}>Error: {errors}</p>}
      {!loader && !errors && (
        <div className="ContainerBox">
          <CustomDataTable columns={columns} data={carts} title="Carts List" />
        </div>
      )}
    </div>
  );
};

export default Cart;
